import * as React from 'react'
import { useEffect, useRef } from 'react'

import { BetaBadge, Button, CoachMark } from '@buffer-mono/popcorn'
import { useCoachMark } from '@buffer-mono/app-shell/src/common/hooks/useCoachMark'

import { useDismissableBanner } from '~publish/hooks/useDismissableBanner'
import { Service } from '~publish/legacy/constants/services/ServiceDefinitions'

import AppStore from '../../../stores/AppStore'

export const ScheduleSelectorCoachmark: React.FC = () => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)
  const [open, setOpen] = React.useState(false)

  const { isCoachMarkActive, onDismissCoachMark } = useCoachMark({
    banner: 'schedule-selector-coachmark-v2',
    coachMarkReleaseDate: '2025-07-01',
    hideForNewUsers: true,
  })

  const onDismiss = (): void => {
    setOpen(false)
    onDismissCoachMark()
  }

  const threadsBanner = useDismissableBanner('threads-hashtag-coachmark')

  const maybeThreadsBannerActive =
    threadsBanner.isActive &&
    AppStore.isTransitionFinished() &&
    AppStore.getSelectedProfiles()
      .map((p) => p.service.name)
      .includes(Service.Threads)

  const maybeOthersActive = maybeThreadsBannerActive

  const shouldShowCoachmark =
    isCoachMarkActive && AppStore.hasProfilesSelected()

  useEffect(() => {
    const shouldOpen = shouldShowCoachmark && !maybeOthersActive
    if (shouldOpen) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
      timeoutRef.current = setTimeout(() => {
        setOpen(true)
      }, 1000)
    }
  }, [shouldShowCoachmark, maybeOthersActive])

  return (
    <CoachMark open={open} dismissTimeout={null} onDismiss={onDismiss}>
      <CoachMark.Overlay>
        <div style={{ width: '20px', height: '20px' }} />
      </CoachMark.Overlay>
      <CoachMark.Content
        side="top"
        align="start"
        showCloseIcon={false}
        style={{
          left: '-130px',
        }}
      >
        <CoachMark.Title>
          <BetaBadge /> A smoother way to schedule
        </CoachMark.Title>
        <CoachMark.Description>
          Add posts to your queue in one click! Publishing now or at a set time
          is still just as easy. We&apos;ve also added a &apos;Create
          Another&apos; option to quickly queue up more posts.
        </CoachMark.Description>
        <CoachMark.Footer>
          <CoachMark.Dismiss>
            <Button variant="primary" size="large">
              Got it
            </Button>
          </CoachMark.Dismiss>
        </CoachMark.Footer>
      </CoachMark.Content>
    </CoachMark>
  )
}
